import { getNomineePayload } from "../utils/nominee/functions";
import { handleApi } from "./common";

export const NOMINEE_API_CONSTANTS = {
  activeNominations: "/api/kyc/nomination/detail",
  createNomineeRequest: "/api/fury/relay/equity/nomination/create/request",
  addNomineeRequest: (requestId) =>
    `/api/fury/relay/equity/nomination/request/${requestId}/create/nominee`,
  updateNomineeRequest: (requestId, nomineeId) =>
    `/api/fury/relay/equity/nomination/request/${requestId}/update/nominee/${nomineeId}`,
  updateNomineeStatus: (requestId, esignDetail) =>
    `/api/fury/relay/equity/nomination/update/request/${requestId}?esign_detail=${esignDetail}`,
  nominationPdfForm:
    "/api/fury/relay/download/static_file/equity_nomination_form",
  nominationFormLink: (docId) =>
    `/api/fury/relay/esign/get/physical_form/${docId}`,
};

export const fetch_nominations = async (Api, token) => {
  const activeNominationsData = await Api.get(
    NOMINEE_API_CONSTANTS.activeNominations,
    {},
    {},
    token
  );
  return handleApi(activeNominationsData);
};

export const create_nominee_request = async (
  Api,
  data,
  file,
  requestId,
  token
) => {
  const formData = new FormData();
  formData.set("file", file);
  const nomineeData = getNomineePayload(data);
  formData.set("nomination", JSON.stringify(nomineeData));
  let url = NOMINEE_API_CONSTANTS.createNomineeRequest;
  if (requestId) {
    url = NOMINEE_API_CONSTANTS.addNomineeRequest(requestId);
  }
  const response = await Api.post(url, formData, {}, token);
  return handleApi(response);
};

export const update_nominee_request = async (
  Api,
  data,
  file,
  requestId,
  nomineeId,
  token
) => {
  const formData = new FormData();
  if (file) {
    formData.set("file", file);
  }
  const nomineeData = getNomineePayload(data);
  formData.set("nomination", JSON.stringify(nomineeData));
  const url = NOMINEE_API_CONSTANTS.updateNomineeRequest(requestId, nomineeId);
  const response = await Api.post(url, formData, {}, token);
  return handleApi(response);
};

export const update_nominee_status = async (
  Api,
  data,
  requestId,
  esignDetail,
  token
) => {
  const url = NOMINEE_API_CONSTANTS.updateNomineeStatus(requestId, esignDetail);
  const response = await Api.post(url, data, {}, token);
  return handleApi(response);
};

export const getManualEsignForm = async (Api, docId, token) => {
  const result = await Api.get(
    NOMINEE_API_CONSTANTS.nominationFormLink(docId),
    {},
    {},
    token
  );
  return handleApi(result);
};
